import {Component} from 'react';
import boulier from './img/boulier.png';
import rectangle from './img/rectangle-pointu.png';

class Boulier extends Component{

	
	
	render (){


		const title = {
			backgroundImage : `url(${rectangle})`,
			backgroundRepeat : `no-repeat`,
			backgroundSize : `contain`,
			textAlign : `left`,
		}

		const imgstyle =  {
			width:`40px`,
			margin:`13px 6px 13px 13px`
		}

		const titlespan = {
			fontSize : `17px`,
			lineHeight:`17px`,
			color:`#fff`,
			fontWeight:`bold`,
			display:`inline-block`,
			width:`100px`,
			position:`relative`,
			top:`-14px`
		}

		return (<div className="title" style={title}> <img src={boulier} style={imgstyle} / > <span style={titlespan} >Les P'tits Simulateurs</span> </div>);
	}
}
export default Boulier;